export default __webpack_public_path__ + "static/GG-8a625191ab8243c106b06bdcf74e5c13.jpg";